import { apiRequest } from "./common";

const login = async (credentials) => {
    const response = await apiRequest('post', '/login', credentials);
    return response.data;
};

const register = async (data) => {
    const response = await apiRequest('post', '/signup', data);
    return response.data;
};

const forgotPassword = async (data) => {
    const response = await apiRequest('post', '/forgot-password', data);
    return response.data;
};

const resetPassword = async (data) => {
    const response = await apiRequest('post', '/reset-password', data);
    return response.data;
};

const getCountries = async (page, size) => {
    const response = await apiRequest('get', `/countries?page=${page}&limit=${size}`);
    return response.data;
};

const userVerify = async (data) => {
    const response = await apiRequest('post', '/otp-verify', data);
    return response.data;
};

const getMeUser = async () => {
    const response = await apiRequest('get', '/me');
    return response.data;
};

const refreshToken = async () => {
    const response = await apiRequest('get', '/refresh-signup-session');
    return response.data;
}

const getUser = async (id) => {
    const response = await apiRequest('get', `/user/${id}`);
    return response.data;
};

const updateUser = async (id, data) => {
    const response = await apiRequest('put', `/user/${id}`, data);
    return response.data;
};

const changePassword = async (data) => {
    const response = await apiRequest('post', `/change-password`, data);
    return response.data;
};

const deleteUser = async (id) => {
    const response = await apiRequest('delete', `/user/${id}`);
    return response.data;
};

const updateStudent = async (id, data) => {
    const response = await apiRequest('put', `/student/${id}`, data);
    return response.data;
};

const resendOtp = async (data) => {
    const response = await apiRequest('post', `/resend-otp`, data);
    return response.data;
};

const getDcpIndexScore = async (studentId) => {
    const response = await apiRequest('get', `/student/${studentId}/dcp-score`);
    return response.data;
};

const getStudentData = async (studentId) => {
    const response = await apiRequest('get', `/student/${studentId}`);
    return response.data;
};

const getUserList = async (pageNo, pagesize, searchText) => {
    const response = await apiRequest('get', `/user?page=${pageNo}&limit=${pagesize}&sort=desc&filters=[{"column":"user_type_id","op":"in","value":"3"}]${searchText !== '' ? `&search=${searchText}` : ''}`);
    return response.data;
};

const blockingUser = async (id, data) => {
    const response = await apiRequest('put', `/user/${id}/change-status`, data);
    return response.data;
};

const adminResetPassword = async (data) => {
    const response = await apiRequest('post', `/admin/reset-user-password`, data);
    return response.data;
};

const SkipIntakeForm = async (data) => {
    const response = await apiRequest('post', `/intake/skip`, data);
    return response.data;
};

const SubmitIntakeForm = async (data) => {
    const response = await apiRequest('post', `/intake/submit`, data);
    return response.data;
};

const getIntakeForm = async (emailId) => {
    const response = await apiRequest('get', `/intake/by-email/${emailId}`);
    return response.data;
};

const updateIntakeForm = async (intakeId, data) => {
    const response = await apiRequest('put', `/intake/${intakeId}`, data);
    return response.data;
};

const saveIntakeForm = async (data) => {
    const response = await apiRequest('post', `/intake/save`, data);
    return response.data;
};

const getTaskDashboard = async () => {
    const response = await apiRequest('get', `/task/dashboard`);
    return response.data;
};

export {
    login,
    register,
    forgotPassword,
    resetPassword,
    getCountries,
    userVerify,
    getMeUser,
    refreshToken,
    getUser,
    updateUser,
    changePassword,
    deleteUser,
    updateStudent,
    resendOtp,
    getDcpIndexScore,
    getStudentData,
    getUserList,
    blockingUser,
    adminResetPassword,
    SkipIntakeForm,
    SubmitIntakeForm,
    getIntakeForm,
    updateIntakeForm,
    saveIntakeForm,
    getTaskDashboard
}